<template>
  <div
    :class="[
      'bb-file-list',
      version && currentFiles.length && `bb-file-list_${version}`
    ]"
  >
    <div
      v-for="item in currentFiles"
      :key="item.id"
      :class="[
        'bb-file-list-item',
        version && `bb-file-list-item_${version}`
      ]"
    >
        <div class="bb-file-list-item__icon">
          <div v-html="fileIcon"/>
        </div>
        <div>
          <div class="bb-file-list-item__name">
            {{ item.label }}
            <div
              :class="[
                'bb-file-list-item__close',
                version && `bb-file-list-item__close_${version}`
              ]"
              v-html="closeIcon"
              @click="onDeleteFile(item)"
            />
          </div>
          <div
            v-if="item.fileSize"
            class="bb-file-list-item__name bb-file-list-item__size"
          >
            {{ item.fileSize }}
          </div>
        </div>
    </div>
  </div>
</template>

<script>

import { FileIcon, CloseIcon } from '@/constants/icon'

export default {
  name: 'BBFileListDefault',
  props: ['currentFiles', 'version'],
  data () {
    return {
      fileIcon: FileIcon(),
      closeIcon: CloseIcon(),
      editItem: {}
    }
  },
  computed: {
    isModalAsset: {
      get () {
        return this.$store.getters.isModalAsset
      },
      set (data) {
        this.$store.dispatch('setModalAsset', data)
      }
    }
  },
  methods: {
    onDeleteFile ({ id, _id }) {
      this.$emit('onDelete', id || _id)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../sass/variables";

.bb-file-list {

    &_image {
      margin: 0 0 10px 0;
      display: flex;
      order: 1;
    }

    &_multi-file {
      margin: 0 0 12px 0;
    }

    &-item {
      display: flex;
      align-items: center;
      width: 100%;
      height: 31px;
      position: relative;

      & + & {
        margin: 10px 0 0 0;
      }

      &_image {
        height: 100%;

        & + & {
          margin: 0 0 0 10px;
        }
      }

      &__right {
        display: flex;
        justify-content: center;
        align-items: center;
      }

      &__icon {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 31px;
        height: 31px;
        color: $color-denim;
        border-radius: 6px;
        background: rgba($color-denim, 0.12);
        margin: 0 8px 0 0;
      }

      &__name {
        font-size: 11px;
        font-weight: 500;
        display: flex;
        align-items: center;
      }

      &__size {
        color: $color-silver-deep;
      }

      &__close {
        color: $color-silver-deep;
        cursor: pointer;
        height: 14px;
        margin: 0 0 0 10px;

        &_multi-file {
          position: absolute;
          right: 0;
          top: 50%;
          transform: translate(0, -50%);
        }
      }

      &__image {
        height: 120px;
        width: 120px;
        border-radius: 2px;
        overflow: hidden;
        position: relative;
        box-shadow: 0 0 5px rgba(0,0,0,.08);

        img {
          height: 100%;
          width: 100%;
          object-fit: cover;
        }

        &:hover {
          opacity: 0.9;

          .bb-file-list-item__dots {
            opacity: 1;
            transition: 0.25s;
          }
        }
      }

      &__dots {
        display: flex;
        opacity: 0;
        justify-content: center;
        align-items: center;
        position: absolute;
        height: 20px;
        width: 20px;
        border-radius: 50%;
        background: $color-wild-sand;
        color: $color-denim;
        box-shadow: 0 0 5px rgba(0,0,0,.1);
        top: 4px;
        right: 4px;
        cursor: pointer;
      }

      &__tool-bar {
        position: absolute;
        padding: 8px;
        border-radius: 5px;
        box-shadow: 0 0 20px rgba(0,0,0,.05);
        background: $color-white;
        top: 4px;
        right: 4px;
      }
    }
  }
</style>

<style lang="scss">
  .bb-file-list-item__close {
    svg {
      width: 14px;
      height: 14px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Main/BBForm/BBFile/BBFileListDefault.vue